import { SignIn } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Brand";

export default function SignInPage() {
    return (
        <div className="min-h-screen bg-paper flex flex-col">
            <header className="px-5 py-4 sm:px-8 sm:py-6">
                <Link
                    to="/"
                    data-testid="signin-brand-link"
                    className="no-underline"
                >
                    <Wordmark height={26} />
                </Link>
            </header>
            <main className="flex-1 flex items-start sm:items-center justify-center px-4 pb-16">
                <div className="w-full max-w-md">
                    <div className="samoony-label mb-3 text-center">
                        Welcome back
                    </div>
                    <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-center mb-6">
                        Sign in to Samoony
                    </h1>
                    <div data-testid="clerk-signin">
                        <SignIn
                            routing="path"
                            path="/sign-in"
                            signUpUrl="/sign-up"
                            forceRedirectUrl="/onboarding"
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}
